module.exports = __webpack_public_path__ + "img/bg-signup@2x.6f61779.jpg";